import { Form, Select } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
    padding: 9px 16px 25px 16px;
    height: calc(80vh - 55px);
    overflow-y: auto;
`;

export const FormItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FormItemLabel = styled.label<{ required?: boolean }>`
    font-size: 14px;
    font-weight: 400;
    color: #262626;
    position: relative;
    padding-left: ${(props) => (props.required ? '10px' : '0px')};

    ${(props) =>
        props.required &&
        `
        &::before {
            content: '*';
            color: #ff4d4e;
            position: absolute;
            left: 0px;
            display: flex;
            align-items: center;
        }
    `}
`;

export const SearchSelect = styled(Select)`
    width: 100%;
    position: relative;

    .ant-select-selector {
        padding-left: 35px !important;
    }

    .ant-select-selection-search-input {
        padding-left: 25px !important;
    }

    & .ant-select-content {
        padding-left: 20px;
    }

    & input {
        padding-left: 20px !important;
    }
`;

export const SearchWrapper = styled.div`
    position: relative;
    width: 100%;
    height: inherit;
`;

export const SearchIcon = styled.div`
    width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    color: #000;
`;

export const FormsWrapper = styled.div<{ hasProduct: boolean }>`
    margin-top: 48px;

    ${(props) =>
        !props.hasProduct &&
        `
        margin-top: 24px !important;
    `}
`;

export const FormItem = styled(Form.Item)`
    margin: 0px !important;

    .ant-row.ant-form-item-row {
        margin-bottom: 0px !important;
        margin-top: 0px !important;
    }
`;

export const LoadingOption = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    pointer-events: none;
`;

export const LoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    z-index: 2;
`;
